import React from 'react';
import './AuthView.less';
import { Row } from 'react-plan';

type Props = {
  children: Object
}

class AuthView extends React.Component {

  description: 'View on top of the Public routes.'

  props: Props

  constructor(props: Props) {
    super(props);
  }

  /* Component Custom Methods */
  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  //componentWillMount() {}
  //componentDidMount() {}
  //componentWillReceiveProps(nextProps) {}
  //shouldComponentUpdate(nextProps, nextState) {}
  //componentWillUpdate(nextProps, nextState) {}
  //componentDidUpdate(prevProps, prevState) {}
  //componentWillUnmount() {}
  render() {
    return (
      <div>
        <Row className="auth-view" justify="center">
          { this.props.children }
        </Row>
      </div>
    );
  }
  /* End React Component LifeCycle Methods */
}

export default AuthView;

//Unit test entry point
export const _AuthView = AuthView;


/** WEBPACK FOOTER **
 ** ./src/js/views/AuthView/AuthView.jsx
 **/